// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\nＦ .colorbase, Ｆ .gray-color, Ｆ .green-color, Ｆ .orange-color, Ｆ .red-color {\n  font-weight: bold;\n  font-size: 14px;\n}\n.red-color {\n  color: red;\n}\n.orange-color {\n  color: orange;\n}\n.green-color {\n  color: green;\n}\n.gray-color {\n  color: #ccc;\n}", ""]);
// Exports
module.exports = exports;
